// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__XT12d","shake":"FloatingButton_shake__m2-Jl"};